import { EuiFlexItem, EuiFlexGroup, EuiButton } from "@elastic/eui";
import { useMemo, useRef } from "react";
import ListaCentrosContainer from "../../../../components/Listas/CentrosSeleccion";
import ModalApp from "../../../../components/Modal";

interface Props{
    isOpen:boolean;
    user:any;
    onClose():void;
    onAddCentros(centros:string):void;
}

export const ModalSelectorCentros = (props:Props) =>{
    const ref:any = useRef();
    const {isOpen,user,onAddCentros,onClose} = props;

    const content = useMemo(() => (isOpen===true ? <ListaCentrosContainer ref={ref} user={user}/> : <></>),[isOpen]);

    const onSave = () =>{
        const dataSave = ref.current && ref.current.onSave();
        onAddCentros(dataSave.toString())
    }

    const footer = (
        <EuiFlexGroup>
            <EuiFlexItem>
                <EuiButton onClick={()=>onSave()}>Guardar</EuiButton>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    )

    return <ModalApp isOpen={isOpen} title='Selector de centros' content={content} contentFooter={footer} onClose={onClose}/>
}